// extracted by mini-css-extract-plugin
module.exports = {"follow-your-competitors-button":"followYourCompetitorsButton_follow-your-competitors-button__3DbbT","hidden":"followYourCompetitorsButton_hidden__3HqBa"};